import { useEffect, useState } from "react";
import { formatCurrency } from "../util";
import loadStatus from "../util/loadStatus";

const useReformulatedData = ({
  project,
  donor,
  donorLoad = loadStatus.loading,
  reformulationItems,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (project.id && donor.id && donorLoad === loadStatus.success) {
      if (donor?.reformulations?.length > 0) {
        setData(
          [
            {
              heading: project.name,
              content: [],
            },
            {
              content: [
                `
                  <q>Community: ${project.community}</q>
                  <q>Address 1: ${project.community_address1}</q>
                  <q>Address 2: ${project.community_address2}</q>
                  <q>Project Location: ${project.project_location}</q>
                  <q>Country: ${project.country}</q>
                  <q>Province: ${project.province}</q>
                  <q>Community Contact Name: ${project.creator?.first_name} ${
                  project.creator.other_names + " " || ""
                }${project.creator?.last_name}</q>
                    <q>Community Contact Email: ${project.creator.email}</q>
                    <q>Community Contact Phone: ${
                      project.creator.phone || "NA"
                    }</q>
      
                    <q>PDO Contact Name: ${project.partners[0]?.first_name}  ${
                  project.partners[0]?.other_names
                    ? project.partners[0]?.other_names + " "
                    : ""
                }${project.partners[0]?.last_name}</q>
                    <q>PDO Contact Email: ${project.partners[0].email}</q>
                    <q>PDO Contact Phone: ${
                      project.partners[0].phone || "NA"
                    }</q>
                    <q>Planned Start Date: ${
                      new Date(project.planned_start_date).toDateString() ||
                      "NA"
                    }</q>
                  <q>Planned End Date: ${
                    new Date(project.planned_end_date).toDateString() || "NA"
                  }</q>
                  <q>Currency: ${
                    project.currency
                      ? project.currency?.name
                      : "N/A" + " (" + project.currency
                      ? project.currency?.symbol
                      : "N/A" + ")"
                  }</q>
                  `,
              ],
            },

            // Start
            ...donor.reformulations.map((item) => {
              if (donor.reformulations.length > 0) {
                if (
                  reformulationItems.find((i) => i.value === item.name).type ===
                  "html"
                ) {
                  return {
                    heading: item.rename,
                    content: [project[item.name]],
                  };
                } else if (
                  reformulationItems.find((i) => i.value === item.name).type ===
                  "text"
                ) {
                  return {
                    content: [
                      `<q>${item.rename}: ${project[item.name] || "N/A"} </q>`,
                    ],
                  };
                } else if (
                  reformulationItems.find((i) => i.value === item.name).type ===
                  "array"
                ) {
                  return {
                    heading: item.rename,
                    content: [
                      {
                        type: "orderedList",
                        items: [...project[item.name].map((i) => i.name)],
                      },
                    ],
                  };
                } else if (
                  reformulationItems.find((i) => i.value === item.name).type ===
                  "budget"
                ) {
                  return {
                    heading: item.rename,
                    content: [
                      {
                        type: "table",
                        rows: [
                          [
                            "No.",
                            "Description",
                            "Category",
                            "Quantity",
                            "Amount",
                            "Total",
                          ],
                          ...project[item.name].map((i, index) => {
                            return [
                              ++index,
                              i.name,
                              i.sub_category,
                              i.quantity,
                              i.amount,
                              formatCurrency(i.quantity * i.amount),
                            ];
                          }),
                          ,
                          [
                            "Total",
                            "",
                            "",
                            "",
                            "",
                            formatCurrency(
                              project[
                                reformulationItems.find(
                                  (i) => i.value === item.name
                                ).value
                              ].reduce(
                                (acc, item) =>
                                  item.amount * item.quantity + acc,
                                0
                              )
                            ),
                          ],
                        ],
                      },
                    ],
                  };
                } else if (
                  reformulationItems.find((i) => i.value === item.name).type ===
                  "category"
                ) {
                  return {
                    heading: item.rename,
                    content: [
                      {
                        type: "table",
                        rows: [
                          ["No.", "Description", "Amount"],
                          ...project[item.name].map((i, index) => {
                            return [
                              ++index,
                              i.name,
                              formatCurrency(Number(i.amount)),
                            ];
                          }),
                          ,
                          [
                            "Total",
                            "",
                            formatCurrency(
                              project[
                                reformulationItems.find(
                                  (i) => i.value === item.name
                                ).value
                              ].reduce(
                                (acc, item) => Number(item.amount) + acc,
                                0
                              )
                            ),
                          ],
                        ],
                      },
                    ],
                  };
                } else {
                  return {};
                }
              }
            }),
            // End
          ].filter((item) => item.content) //Filter out the empty items
        );
      } else {
        setData([
          {
            heading: project.name,
            content: [],
          },
          {
            content: [
              `
                <q>Community: ${project.community}</q>
                <q>Address 1: ${project.community_address1}</q>
                <q>Address 2: ${project.community_address2}</q>
                <q>Project Location: ${project.project_location}</q>
                <q>Country: ${project.country}</q>
                <q>Province: ${project.province}</q>
                <q>Community Contact Name: ${project.creator?.first_name} ${
                project.creator.other_names + " " || ""
              }${project.creator?.last_name}</q>
                  <q>Community Contact Email: ${project.creator.email}</q>
                  <q>Community Contact Phone: ${
                    project.creator.phone || "NA"
                  }</q>
    
                  <q>PDO Contact Name: ${project.partners[0]?.first_name}  ${
                project.partners[0]?.other_names
                  ? project.partners[0]?.other_names + " "
                  : ""
              }${project.partners[0]?.last_name}</q>
                  <q>PDO Contact Email: ${project.partners[0].email}</q>
                  <q>PDO Contact Phone: ${project.partners[0].phone || "NA"}</q>
                  <q>Planned Start Date: ${
                    new Date(project.planned_start_date).toDateString() || "NA"
                  }</q>
                  <q>Planned End Date: ${
                    new Date(project.planned_end_date).toDateString() || "NA"
                  }</q>
                  <q>Currency: ${project.currency?.name}</q>
                `,
            ],
          },
          {
            heading: "Description",
            content: [project.description],
          },
          {
            heading: "Goal",
            content: [project.aim],
          },
          {
            heading: "Purpose",
            content: [project.purpose],
          },

          {
            heading: "Objectives",
            content: [[...project.objectives.map((i) => i.name)]],
          },
          {
            heading: "Planned Measures Activities",
            content: [
              {
                type: "orderedList",
                items: [...project.activities.map((i) => i.name)],
              },
            ],
          },
          {
            heading: "Results",
            content: [
              {
                type: "orderedList",
                items: [...project.expected_results.map((i) => i.name)],
              },
            ],
          },
          {
            heading: "Selected Indicators",
            content: [project.selected_indicators],
          },
          {
            heading: "Sustainability Plan",
            content: [project.sustainability_plan],
          },
          {
            heading: "Justification",
            content: [project.justification],
          },
          {
            heading: "Monitoring and Supervision",
            content: [project.monitoring_supervision],
          },
          {
            heading:
              "How This Project Helps Address The Issues Of The GC26 & DC27",
            content: [project.issues],
          },
          {
            content: [
              `<q>Target Group: ${project.stakeholder_target_group}</q>`,
            ],
          },
          {
            content: [
              `<q>Male Beneficiaries: ${project.male_beneficiaries}</q>`,
            ],
          },
          {
            content: [
              `<q>Femaile Beneficiaries: ${project.female_beneficiaries}</q>`,
            ],
          },

          {
            heading: "Budget",
            content: [
              {
                type: "table",
                rows: [
                  [
                    "No.",
                    "Description",
                    "Category",
                    "Quantity",
                    "Amount",
                    "Total",
                  ],

                  ...project.budget.map((i, index) => {
                    return [
                      ++index,
                      i.name,
                      i.sub_category,
                      i.quantity,
                      i.amount,
                      formatCurrency(i.quantity * i.amount),
                    ];
                  }),
                  ,
                  [
                    "Total",
                    "",
                    "",
                    "",
                    "",
                    formatCurrency(
                      project.budget.reduce(
                        (acc, item) => item.amount * item.quantity + acc,
                        0
                      )
                    ),
                  ],
                ],
              },
            ],
          },
          //End one
          {
            heading: "Budget by Category",
            content: [
              {
                type: "table",
                rows: [
                  ["No.", "Description", "Amount"],

                  ...project.catBudget.map((i, index) => {
                    return [++index, i.name, formatCurrency(i.amount)];
                  }),
                  ,
                  [
                    "Total",
                    "",
                    formatCurrency(
                      project.catBudget.reduce(
                        (acc, item) => Number(item.amount) + acc,
                        0
                      )
                    ),
                  ],
                ],
              },
            ],
          },
          //End of Budget
        ]);
      }
    }
  }, [project, donor, reformulationItems]);

  return data;
};

export default useReformulatedData;
